export default __webpack_public_path__ + "static/media/Background_00276.8149e470.png";